package com.milta.core.localization

/**
 * Public web pages reachable without signing in (`/delete-account`, Google Play requirement) — see
 * `webApp`'s `PublicPages.kt`. The French text is the source of truth: every sentence was checked
 * against the backend (ConfirmAccountDeletionHandler, RequestAccountDeletionHandler,
 * DeleteEnterpriseHandler) and the published privacy policy, so translations must not add, drop
 * or rephrase anything. App labels quoted in the steps ("Profil", "Supprimer mon compte", …) are
 * copied from [HomeStrings.navProfile], [ProfileStrings.deleteAccount],
 * [ProfileStrings.deleteAccountDialogConfirm], [ProfileStrings.deleteAccountConfirmButton],
 * [CommonStrings.navParametres] and [SettingsStrings.deleteSectionTitle] of the same language, so
 * the user finds the exact same word on screen. « Compte supprimé » stays in French everywhere:
 * the backend writes that literal name on the anonymized account, whatever the language.
 */
data class PublicPagesStrings(
    val deleteAccountTitle: String,
    val deleteAccountIntro: String,

    // Section "Depuis l'application Milta"
    val deleteAccountInAppTitle: String,
    /** Numbered steps, rendered as an ordered list. */
    val deleteAccountInAppSteps: List<String>,
    val deleteAccountEnterpriseNote: String,

    // Section "Sans accès à l'application"
    val deleteAccountNoAppTitle: String,
    /** Contient un "%s" — l'adresse e-mail de contact, jamais traduite, rendue en lien mailto. */
    val deleteAccountNoAppText: String,

    // Section "Ce qui est supprimé"
    val deleteAccountDeletedTitle: String,
    val deleteAccountDeletedItems: List<String>,

    // Section "Ce qui peut être conservé"
    val deleteAccountKeptTitle: String,
    val deleteAccountKeptItems: List<String>,

    // Section "Supprimer une organisation (compte Entreprise)"
    val deleteOrganizationTitle: String,
    val deleteOrganizationText: String,

    /** Footer link to `/privacy`. */
    val privacyPolicyLink: String,
)
